export default {
  GET_SECTIONS: state => state.sections,
  GET_APARTMENT_SECTIONS_FOR_SELECT: state => state.sectionsForSelect,
  GET_SECTIONS_COUNT: state => state.sections.count,
}